const MUTUAL_GBS_DEPARTMENTS = new Set(['Mutual', 'GBS'])

export const isMutualGbsDepartment = (department) => {
  if (!department) return false
  return MUTUAL_GBS_DEPARTMENTS.has(String(department))
}

const DEFAULT_SAI_TERMS = Object.freeze({
  policyInfo: {
    columns: [
      { key: 'staffType', label: 'Staff Type' },
      { key: 'fte', label: 'Purchased FTE', format: 'fte', totalKey: 'purchasedFte' },
      { key: 'submitted', label: 'Submitted FTE', fallbackKey: 'submitted_sc', format: 'fte', totalKey: 'submittedFte' },
      { key: 'benefit', label: 'Benefit' },
      { key: 'excess', label: 'Excess' },
      { key: 'period', label: 'Period' },
      { key: 'stress', label: 'Stress' },
      { key: 'maternity', label: 'Maternity FTE', format: 'fte', totalKey: 'maternityFte' },
      { key: 'maternityCover', label: 'Maternity Cover' },
    ],
  },
  policy: {
    singularTitle: 'Policy',
    singularLower: 'policy',
  },
  claim: {
    singularTitle: 'Claim',
    pluralTitle: 'Claims',
    singularLower: 'claim',
    pluralLower: 'claims',
  },
})

const MUTUAL_GBS_SAI_TERMS = Object.freeze({
  policyInfo: DEFAULT_SAI_TERMS.policyInfo,
  policy: {
    singularTitle: 'Scheme',
    singularLower: 'scheme',
  },
  claim: {
    singularTitle: 'Payment Request',
    pluralTitle: 'Payment Requests',
    singularLower: 'payment request',
    pluralLower: 'payment requests',
  },
})

const MUTUAL_SAI_TERMS = Object.freeze({
  ...MUTUAL_GBS_SAI_TERMS,
  policyInfo: {
    columns: [
      { key: 'staffType', label: 'Staff Type' },
      { key: 'fte', label: 'FTE', format: 'fte', totalKey: 'purchasedFte' },
      { key: 'benefit', label: 'Daily Reimbursement' },
      { key: 'excess', label: 'Waiting Period' },
      { key: 'period', label: 'Benefit Days' },
      { key: 'stress', label: 'Stress Limit' },
      // { key: 'maternity', label: 'Maternity Reimbursement', format: 'fte', totalKey: 'maternityFte' },
      { key: 'maternityCover', label: 'Maternity Reimbursement' },
    ],
  },
})

/**
 * Staff Absence / SAI terminology varies by department.
 *
 * - SAS/AIS: "Policy" + "Claims"
 * - Mutual/GBS: "Scheme" + "Payment Requests"
 */
export const getSaiTerminology = (policyDataOrDepartment) => {
  const department =
    typeof policyDataOrDepartment === 'string'
      ? policyDataOrDepartment
      : policyDataOrDepartment?.department

  if (department === 'Mutual') return MUTUAL_SAI_TERMS
  if (isMutualGbsDepartment(department)) return MUTUAL_GBS_SAI_TERMS
  return DEFAULT_SAI_TERMS
}
